import React from 'react'

import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'
import {useIsHydrated} from '@vio/core/src/utils/react/hooks/useIsHydrated'
import {CookieConsentBannerWithStore} from '@vio/shared/src/search/cookies'

const CookieBannerComponent = () => {
  const {compliance} = useBrandCapabilities()
  const isHydrated = useIsHydrated()

  if (!isHydrated || !compliance.cookieConsent.enabled) return null

  return <CookieConsentBannerWithStore />
}

export const CookieBanner = React.memo(CookieBannerComponent)
